import { guid } from '@tencent/glue-util-helper';
import { AnimationManager } from './AnimationManager';
import { AnimationTick } from './AnimationTick';
var H5AnimationExecutor = /** @class */ (function () {
    function H5AnimationExecutor(transform, prop, instance) {
        this.id = guid();
        this.callbacks = null;
        this.running = false;
        this.startTime = 0;
        this.timeSpan = 0;
        this.repeat = 0;
        this.instance = instance;
        this.transform = transform;
        this.prop = prop;
        this.instance.setExecutor(this);
        this.isColor = prop === 'color' || prop === 'backgroundColor';
        this.tickManager = new AnimationTick(this.instance.isChain()
            ? this.instance.getOptions().animations
            : [this.instance.getOptions()], this.isColor);
        this.currentValue = this.tickManager.getStartValue();
    }
    H5AnimationExecutor.prototype.getId = function () {
        return this.id;
    };
    H5AnimationExecutor.prototype.getInstance = function () {
        return this.instance;
    };
    H5AnimationExecutor.prototype.getTransform = function () {
        return this.transform;
    };
    H5AnimationExecutor.prototype.getCurrentValue = function () {
        return this.currentValue;
    };
    H5AnimationExecutor.prototype.setCallbacks = function (callbacks) {
        this.callbacks = callbacks;
    };
    H5AnimationExecutor.prototype.updateAnimate = function () {
        if (this.running) {
            return;
        }
        this.tickManager = new AnimationTick(this.instance.isChain()
            ? this.instance.getOptions().animations
            : [this.instance.getOptions()], this.isColor);
        this.currentValue = this.tickManager.getStartValue();
    };
    H5AnimationExecutor.prototype.start = function () {
        if (this.running) {
            return;
        }
        this.running = true;
        this.startTime = +Date.now();
        this.timeSpan = 0;
        this.repeat = this.instance.getOptions().repeatCount || 0;
        AnimationManager.manager.register(this);
    };
    H5AnimationExecutor.prototype.pause = function () {
        AnimationManager.manager.unregister(this);
    };
    H5AnimationExecutor.prototype.resume = function () {
        this.startTime = Date.now() - this.timeSpan;
        AnimationManager.manager.register(this);
    };
    H5AnimationExecutor.prototype.dispose = function () {
        AnimationManager.manager.unregister(this);
    };
    H5AnimationExecutor.prototype.tick = function () {
        var _a, _b;
        var timeSpan = Date.now() - this.startTime;
        var total = this.tickManager.getTotalTime();
        var repeatCount = Math.floor(timeSpan / total);
        var tickSpan = timeSpan % total;
        if (this.repeat >= 0 && repeatCount > this.repeat) {
            AnimationManager.manager.unregister(this);
            this.running = false;
            tickSpan = total;
            (_b = (_a = this.callbacks) === null || _a === void 0 ? void 0 : _a.onAnimationEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        this.timeSpan = timeSpan;
        var currentValue = this.tickManager.tick(tickSpan);
        if (currentValue !== this.currentValue) {
            this.currentValue = currentValue;
            return true;
        }
        return false;
    };
    return H5AnimationExecutor;
}());
export { H5AnimationExecutor };
